module.exports = __webpack_public_path__ + "img/blue_093.0aa9f79b.png";